<div class="user-avatar-cropper-dialog">
    <div class="flex items-start justify-between gap-4 px-6 pt-6">
        <div>
            <div class="text-xl font-semibold leading-6">Profilbild anpassen</div>
        </div>
        <button [mat-dialog-close]="null" mat-icon-button matTooltip="Schließen" type="button">
            <mat-icon [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>

    <div class="px-6 py-5">
        <div class="avatar-cropper-stage">
            <img #image [src]="imageUrl" alt="Avatar zuschneiden">
        </div>

        <div class="mt-4 flex flex-wrap items-center justify-center gap-2">
            <button (click)="zoomOut()" mat-icon-button matTooltip="Verkleinern" type="button">
                <mat-icon [svgIcon]="'heroicons_outline:minus'"></mat-icon>
            </button>
            <button (click)="zoomIn()" mat-icon-button matTooltip="Vergrößern" type="button">
                <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
            </button>
            <button (click)="rotateLeft()" mat-icon-button matTooltip="Links drehen" type="button">
                <mat-icon [svgIcon]="'heroicons_outline:reply'"></mat-icon>
            </button>
            <button (click)="rotateRight()" mat-icon-button matTooltip="Rechts drehen" type="button">
                <mat-icon [svgIcon]="'heroicons_outline:refresh'"></mat-icon>
            </button>
            <button (click)="reset()" mat-icon-button matTooltip="Zurücksetzen" type="button">
                <mat-icon [svgIcon]="'heroicons_outline:refresh'"></mat-icon>
            </button>
        </div>

        <div *ngIf="errorMessage" class="mt-4 rounded-md bg-red-50 px-4 py-3 text-sm text-red-700">
            {{ errorMessage }}
        </div>
    </div>

    <div class="flex items-center justify-end gap-3 border-t px-6 py-4">
        <button [mat-dialog-close]="null" mat-button type="button">Abbrechen</button>
        <button (click)="crop()" [color]="'primary'" [disabled]="processing" mat-flat-button type="button">
            <span *ngIf="!processing">Übernehmen</span>
            <mat-progress-spinner *ngIf="processing" [diameter]="22" [mode]="'indeterminate'"></mat-progress-spinner>
        </button>
    </div>
</div>
